import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import {
  OrderCancelConfirmComponent,
  OrderCancelConfirmData
} from 'src/app/modals/order-cancel-confirm/order-cancel-confirm.component';
import { RejectionReasonComponent } from 'src/app/modals/rejection-reason/rejection-reason.component';

@Injectable({
  providedIn: 'root'
})
export class OrderCancelDialogService {
  constructor(private dialog: MatDialog) {}

  requestAdminCancellation(
    order?: OrderCancelConfirmData
  ): Observable<string | null> {
    return this.dialog
      .open(OrderCancelConfirmComponent, {
        width: '420px',
        maxWidth: '95vw',
        panelClass: ['modall', 'order-cancel-confirm-panel'],
        disableClose: true,
        autoFocus: false,
        data: order ?? {}
      })
      .afterClosed()
      .pipe(
        switchMap((confirmed: boolean) => {
          if (!confirmed) {
            return of(null);
          }

          return this.dialog
            .open(RejectionReasonComponent, {
              panelClass: ['modall'],
              disableClose: true,
              autoFocus: false
            })
            .afterClosed();
        })
      );
  }
}
